import { createAsyncLocalStorage } from './async-local-storage';
export const actionAsyncStorageInstance = createAsyncLocalStorage();

//# sourceMappingURL=action-async-storage-instance.js.map